import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Florencia M.',
  role: 'Contadora',
  city: 'Buenos Aires',
  quote: 'Después de años probando dietas que no funcionaban, entendí que el problema no era mi disciplina sino mi timing. Con el Código Hormonal empecé a comer según mi fase y en 3 semanas ya noté menos hinchazón, más energía y dormía mejor. Ojalá lo hubiera tenido antes.',
  avatar: 'https://images.unsplash.com/photo-1611432579699-484f7990b127?w=250&h=250&fit=crop&crop=face'
}, {
  name: 'Valentina R.',
  role: 'Emprendedora',
  city: 'Córdoba',
  quote: 'Tengo SOP y siempre sentí que mi cuerpo iba en contra mía. Este ebook me enseñó a trabajar CON mis hormonas. El plan de 28 días es súper claro y las recetas son con ingredientes que consigo en cualquier súper. Por primera vez siento que tengo el control.',
  avatar: 'https://images.unsplash.com/photo-1618835962148-cf177563c6c0?w=250&h=250&fit=crop&crop=face'
}, {
  name: 'Camila S.',
  role: 'Profesora de Yoga',
  city: 'Rosario',
  quote: 'Lo que más me sorprendió fue la sección de entrenamiento cíclico. Yo hacía HIIT todos los días y no entendía por qué estaba agotada. Ahora adapto mi movimiento a cada fase y los resultados son increíbles. Mi cuerpo cambió sin forzarlo.',
  avatar: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=250&h=250&fit=crop&crop=face'
}, {
  name: 'Agustina L.',
  role: 'Diseñadora Gráfica',
  city: 'Mendoza',
  quote: 'Estaba en premenopausia y nadie me explicaba qué pasaba con mi cuerpo. El Código Hormonal me dio respuestas claras y un protocolo adaptado. La cocina biohacker es un golazo: recetas ricas, fáciles y pensadas para nosotras. 100% recomendado.',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=250&h=250&fit=crop&crop=face'
}];
export function TestimonialsSection() {
  return <section className="w-full py-10 md:py-16 px-4 bg-[#F3E8F0]" data-id="element-137">
      <div className="max-w-6xl mx-auto" data-id="element-138">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-3 text-brand-text-primary" data-id="element-139">
          Lo Que Dicen Quienes Ya Lo Aplicaron
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-center text-brand-text-muted mb-8 md:mb-12 max-w-xl mx-auto" data-id="element-140">
          Mujeres reales, resultados reales.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" data-id="element-141">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-5 md:p-7 shadow-sm border border-[#E8D8E0] flex flex-col items-center text-center" data-id="element-142">
              <img src={t.avatar} alt={t.name} className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-3 border-brand-gold/40 shadow-md mb-4" data-id="element-143" />

              <h3 className="text-lg font-bold text-brand-text-primary" data-id="element-144">
                {t.name}
              </h3>
              <p className="text-sm italic text-brand-purple-light mb-1" data-id="element-145">
                {t.role} — {t.city}
              </p>

              <div className="flex gap-0.5 mb-3" data-id="element-146">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-147" />)}
              </div>

              <p className="text-brand-text-body text-sm leading-relaxed" data-id="element-148">
                "{t.quote}"
              </p>

              <div className="w-16 h-0.5 bg-brand-gold/30 mt-5 rounded-full" data-id="element-149" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}